// extracted by mini-css-extract-plugin
export default {"titleContainer":"Header_titleContainer__9jB4N","backContainer":"Header_backContainer__epth1"};